import React, { useState, useRef, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import { updateModalContent, toggleModal } from '../../actions/modal';
import PostalCodeTable from './postalCodeTable';
import { getPostalCodesWithNoLatLng } from '../../actions/admin/dashboardAction';
import AddressTable from './table';
import CreateAddress from './create';

const AddressList = (props) => {
  const formCreateRef = useRef();
  const [tableDataState, setTableDataState] = useState(false);
  const [postalCodeData, setPostalCodeData] = useState({});
  const [reloadTable, setReloadTable] = useState(true);

  const getPostalCodeData = async () => {
    await props.getPostalCodesWithNoLatLng()
      .then((data) => {
        setPostalCodeData(data);
      })
      .catch((err) => toast.error(err));
  };

  useEffect(() => {
    if (reloadTable) {
      getPostalCodeData();
      setReloadTable(false);
    }
  }, [reloadTable]);

  const handleUpdateTable = () => {
    setTableDataState(true);
  };

  const onAddNewAddress = () => {
    props.updateModalContent({
      title:        'Add New Address',
      content:      <CreateAddress updateList={handleUpdateTable} reloadPostalCodeTable={() => setReloadTable(true)} ref={formCreateRef} />,
      actionButton: {
        actionText: 'Save',
        actionType: 'primary',
        action:     () => formCreateRef.current.submitForm(),
      },
      cancelText:       'Cancel',
      closeAfterAction: false,
    });

    props.toggleModal();
  };

  return (
    <div className="d-flex flex-column">
      <div className="content-header">
        <h1>Address</h1>
      </div>

      {/* <Typography className="mt-2 mb-2 ml-2" variant="h5">List of postal codes with no Lat & Lng data</Typography> */}
      <Typography className="mt-2 mb-2 ml-2" variant="h5">List of address information from different sections.</Typography>
      <Typography className="mb-2 ml-2" variant="subtitle1">*The following address information below doesn\'t match nor exist in our address database needs to be handled:</Typography>

      <PostalCodeTable data={postalCodeData} />

      <div className="d-flex flex-row justify-content-between mt-5 mb-3 mx-2">
        <Typography className="" variant="h5">Addresses</Typography>
        <Button variant="contained" color="primary" onClick={() => onAddNewAddress()}>+ Address</Button>
      </div>
      <AddressTable updateListOnCreate={tableDataState} resetValue={() => setTableDataState(false)} reloadPostalCodeTable={() => setReloadTable(true)} />
    </div>
  );
};

AddressList.propTypes = {
  getPostalCodesWithNoLatLng: PropTypes.func.isRequired,
  updateModalContent:         PropTypes.func.isRequired,
  toggleModal:                PropTypes.func.isRequired,
};

export default connect(null, {
  toggleModal,
  updateModalContent,
  getPostalCodesWithNoLatLng,
})(AddressList);
